import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { UserLoginComponent } from './auth/login/user-login.component';
import { DashboardcommonComponent } from './dashboardcommon/dashboardcommon.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { LocalStorageModule } from 'angular-2-local-storage';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonService } from './common/common.service';
import * as $ from 'jquery';
import { DashboardsubmenuComponent } from './dashboardsubmenu/dashboardsubmenu.component';
import { ReactiveFormsModule } from '@angular/forms';

// import { UsermasterComponent } from './users/usermaster/usermaster.component';
import { ForgotpasswordComponent } from './auth/forgotpassword/forgotpassword.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ProfileComponent } from './profile/profile.component';
import { UsermanualComponent } from './usermanual/usermanual.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CommonHeaderComponent } from './layout/common-layout/common-header/common-header.component';
import { CommonFooterComponent } from './layout/common-layout/common-footer/common-footer.component';
import { CommonContainerComponent } from './layout/common-layout/common-container/common-container.component';
import { WebsiteContainerComponent } from './layout/website-layout/website-container/website-container.component';
import { WebsiteFooterComponent } from './layout/website-layout/website-footer/website-footer.component';
import { WebsiteHeaderComponent } from './layout/website-layout/website-header/website-header.component';
import { WebsiteNavbarComponent } from './layout/website-layout/website-navbar/website-navbar.component';
import { UserHeaderComponent } from './layout/user-layout/user-header/user-header.component';
import { UserFooterComponent } from './layout/user-layout/user-footer/user-footer.component';
import { UserContainerComponent } from './layout/user-layout/user-container/user-container.component';
import { UserNavigationComponent } from './layout/user-layout/user-navigation/user-navigation.component';


const Common_Layout = [CommonHeaderComponent, CommonFooterComponent, CommonContainerComponent];
const User_Layout = [UserHeaderComponent, UserFooterComponent,UserNavigationComponent, UserContainerComponent];

const Website_Layout = [WebsiteContainerComponent, WebsiteFooterComponent, WebsiteHeaderComponent, WebsiteNavbarComponent];

@NgModule({
  declarations: [
    AppComponent,
    Common_Layout,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    DashboardComponent,
    LoginComponent,
    DashboardcommonComponent,
    DashboardsubmenuComponent,
    ForgotpasswordComponent,
    ChangepasswordComponent,
    ProfileComponent,
    UsermanualComponent,
    Website_Layout,
    User_Layout,
    UserLoginComponent
  ],
  
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    PdfViewerModule,
    NgHttpLoaderModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      closeButton: true,
    }),

    LocalStorageModule.forRoot({
      storageType: 'localStorage',
      prefix: '',
    }),
  ],

  providers: [CommonService],
  bootstrap: [AppComponent],
})
export class AppModule { }